export default function LogChatAmountDisplay ({
    total = 0,
}: {
    total?: number,
}) {
    if (total > 0) {
        return <span> ({total})</span>
    }
    return null
}
